import { render, staticRenderFns } from "./bankCredit.vue?vue&type=template&id=3672feee&scoped=true&"
import script from "./bankCredit.vue?vue&type=script&lang=js&"
export * from "./bankCredit.vue?vue&type=script&lang=js&"
import style0 from "./bankCredit.vue?vue&type=style&index=0&id=3672feee&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3672feee",
  null
  
)

export default component.exports